/* Your JS Code goes here */
import './bootstrap.bundle.min.js';
import Isotope from 'isotope-layout';

import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

document.documentElement.classList.add('has-js-motion');

function initRevealMotion() {
	const revealSelectors = [
		'.rr-page__head',
		'.rr-page__lead',
		'.rr-richtext > *',
		'.o-home-hero__copy',
		'.o-home-hero__panel',
		'.o-home-hero__slider',
		'.o-news-grid .rr-section__head',
		'.o-news-grid__list .o-news-card',
		'.o-member-marquee__head',
		'.o-member-marquee__viewport',
		'.o-home-events__head',
		'.o-home-events__rail .o-home-event',
		'.o-home-join-band__inner',
		'.o-photo-gallery .rr-section__head',
		'.o-photo-gallery__head',
		'.o-photo-gallery__grid .o-photo-gallery__item',
		'.o-news-listing__head',
		'.o-news-listing__item',
		'.o-events-calendar__head',
		'.o-events-calendar__toolbar',
		'.o-events-calendar__monthbar',
		'.o-events-calendar__grid',
		'.o-events-calendar__list',
		'.o-events-calendar__item',
		'.o-events-calendar__pager',
		'.o-directory__head',
		'.o-directory__grid .o-biz',
		'.o-board__head',
		'.o-board__grid .o-board__card',
		'.o-member-wall__cell',
		'.o-events-gallery__cell',
		'.o-membership-form__intro',
		'.o-membership-form__benefits',
		'.o-membership-form__panel',
		'.o-join-cta__inner',
	];

	const targets = Array.from(document.querySelectorAll(revealSelectors.join(', ')));
	if (!targets.length || !('IntersectionObserver' in window)) {
		targets.forEach(function (el) {
			el.classList.add('is-revealed');
		});
		return;
	}

	const observer = new IntersectionObserver(
		function (entries, io) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) {
					return;
				}

				entry.target.classList.add('is-revealed');
				io.unobserve(entry.target);
			});
		},
		{
			root: null,
			rootMargin: '0px 0px -8% 0px',
			threshold: 0.16,
		}
	);

	targets.forEach(function (el, index) {
		el.classList.add('rr-reveal');

		if (
			el.matches('.o-news-grid__list .o-news-card, .o-home-events__rail .o-home-event, .o-photo-gallery__grid .o-photo-gallery__item, .o-news-listing__item, .o-events-calendar__item, .o-directory__grid .o-biz, .o-board__grid .o-board__card, .o-member-wall__cell, .o-events-gallery__cell')
		) {
			el.classList.add('rr-reveal--lift');
		}

		if (index % 3 === 0) {
			el.classList.add('rr-reveal--slow');
		}

		observer.observe(el);
	});
}

document.addEventListener('DOMContentLoaded', initRevealMotion);

// init Isotope
let $isotope = null;
var grid = document.querySelector('.row-isotope');

// document.addEventListener('DOMContentLoaded', function () {
// 	if (grid) {
// 		$isotope = new Isotope(grid, {
// 			itemSelector: '.o-event-list__item-list__item',
// 			layoutMode: 'masonry',
// 			filter: ':not(.hide-all)',
// 		});
//
// 		var filterButtons = document.querySelectorAll('.filters-button-group .button');
// 		filterButtons.forEach(function (button) {
// 			button.addEventListener('click', function () {
// 				// Get filter value from data-filter attribute
// 				var filterValue = this.getAttribute('data-filter');
//
// 				$isotope.arrange({ filter: filterValue });
//
// 				filterButtons.forEach(function (btn) {
// 					btn.classList.remove('is-active');
// 				});
//
// 				this.classList.add('is-active');
// 				$isotope.layout();
// 				setTimeout(() => {
// 					$isotope.layout();
// 				}, 500);
// 			});
// 		});
//
// 		var filterType = document.querySelectorAll('.filters-button-type .button');
// 		filterType.forEach(function (button) {
// 			button.addEventListener('click', function () {
// 				// Get filter value from data-filter attribute
// 				var filterValue = this.getAttribute('data-filter');
//
// 				$isotope.arrange({ filter: filterValue });
//
// 				filterType.forEach(function (btn) {
// 					btn.classList.remove('is-active');
// 				});
//
// 				this.classList.add('is-active');
// 				$isotope.layout();
// 				setTimeout(() => {
// 					$isotope.layout();
// 				}, 500);
// 			});
// 		});
// 	}
// });

document.addEventListener('DOMContentLoaded', function () {
	var grid = document.querySelector('.row-isotope');
	if (grid) {
		var $isotope = new Isotope(grid, {
			itemSelector: '.o-event-list__item-list__item',
			layoutMode: 'masonry',
			filter: '*',
		});

		var filterMonthButtons = document.querySelectorAll(
			'.filters-button-group .button'
		);
		var filterTypeButtons = document.querySelectorAll(
			'.filters-button-type .button'
		);
		var imageCheckbox = document.getElementById('imageCheckbox');
		var clearFiltersA = document.getElementById('clear-filters');
		var monthText = document.getElementById('month-filter-text');
		var typeText = document.getElementById('type-filter-text');

		clearFiltersA.addEventListener('click', function () {
			imageCheckbox.checked = false;
			monthText.innerText = ' Zeitraum wählen';
			typeText.innerText = ' Zielgruppe wählen ';
			applyFilters('*', '', '');
		});

		function handleMonthFilterClick(buttons) {
			buttons.forEach(function (button) {
				button.addEventListener('click', function () {
					var filterValue = this.getAttribute('data-filter');
					filterMonthButtons.forEach(function (btn) {
						btn.classList.remove('is-active');
					});
					this.classList.add('is-active');
					if (filterValue === '*') monthText.innerText = ' Zeitraum wählen ';
					else monthText.innerText = this.innerText;
					var monthFilter = filterValue === '*' ? '' : filterValue;
					var typeFilter = getTypeFilter();
					var imageFilter = getImageFilter();
					applyFilters(monthFilter, typeFilter, imageFilter);
				});
			});
		}

		function handleTypeFilterClick(buttons) {
			buttons.forEach(function (button) {
				button.addEventListener('click', function () {
					var filterValue = this.getAttribute('data-filter');
					filterTypeButtons.forEach(function (btn) {
						btn.classList.remove('is-active');
					});
					this.classList.add('is-active');
					if (filterValue === '*') typeText.innerText = ' Zielgruppe wählen ';
					else typeText.innerText = this.innerText;
					var monthFilter = getMonthFilter();
					var typeFilter = filterValue === '*' ? '' : filterValue;
					var imageFilter = getImageFilter();
					applyFilters(monthFilter, typeFilter, imageFilter);
				});
			});
		}

		function handleImageCheckboxClick() {
			imageCheckbox.addEventListener('change', function () {
				var monthFilter = getMonthFilter();
				var typeFilter = getTypeFilter();
				var imageFilter = this.checked ? '.bildungsurlaub' : '';
				applyFilters(monthFilter, typeFilter, imageFilter);
			});
		}
		function applyFilters(monthFilter, typeFilter, imageFilter) {
			var combinedFilter = '';
			if (monthFilter || typeFilter) {
				combinedFilter = (monthFilter || '') + (typeFilter || '');
			}
			if (combinedFilter && imageFilter) {
				combinedFilter += ', ';
			}
			combinedFilter += imageFilter;
			$isotope.arrange({ filter: combinedFilter });
		}

		function getMonthFilter() {
			var activeMonthButton = document.querySelector(
				'.filters-button-group .button.is-active'
			);
			if (activeMonthButton)
				return activeMonthButton.getAttribute('data-filter');
			return '';
		}

		function getTypeFilter() {
			var activeTypeButton = document.querySelector(
				'.filters-button-type .button.is-active'
			);
			if (activeTypeButton) {
				if (activeTypeButton.getAttribute('data-filter') === '*') return '';
				return activeTypeButton.getAttribute('data-filter');
			}
			return '';
		}

		function getImageFilter() {
			return imageCheckbox.checked ? '.has-image' : '';
		}

		handleMonthFilterClick(filterMonthButtons);
		handleTypeFilterClick(filterTypeButtons);
		handleImageCheckboxClick();
	}
});

document.querySelectorAll('.o-carousel').forEach(function (carouselContainer) {
	const swiper = new Swiper(
		carouselContainer.querySelector('.o-carousel__slides'),
		{
			// configure Swiper to use modules
			modules: [Navigation, Pagination],
			slidesPerView: 1.9,
			spaceBetween: 15,
			navigation: {
				nextEl: carouselContainer.querySelector('.swiper-button-next'),
				prevEl: carouselContainer.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				768: {
					slidesPerView: 1.9,
					spaceBetween: 15,
				},
				1201: {
					slidesPerView: 1.9,
					spaceBetween: 30,
				},
				1920: {
					slidesPerView: 1.9,
					spaceBetween: 30,
				},
				3200: {
					slidesPerView: 2.2,
					spaceBetween: 30,
				},
			},
		}
	);
});

document.querySelectorAll('.o-home-hero__slider').forEach(function (heroSlider) {
	new Swiper(heroSlider, {
		modules: [EffectFade, Navigation, Pagination, Autoplay],
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		speed: 700,
		loop: heroSlider.querySelectorAll('.swiper-slide').length > 1,
		autoplay: {
			delay: 5200,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: heroSlider.querySelector('.swiper-button-next'),
			prevEl: heroSlider.querySelector('.swiper-button-prev'),
		},
		pagination: {
			el: heroSlider.querySelector('.swiper-pagination'),
			clickable: true,
		},
	});
});

document.querySelectorAll('.rr-event-gallery__slider').forEach(function (gallerySlider) {
	new Swiper(gallerySlider, {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		spaceBetween: 16,
		speed: 450,
		loop: gallerySlider.querySelectorAll('.swiper-slide').length > 1,
		navigation: {
			nextEl: gallerySlider.querySelector('.rr-event-gallery__next'),
			prevEl: gallerySlider.querySelector('.rr-event-gallery__prev'),
		},
		pagination: {
			el: gallerySlider.querySelector('.rr-event-gallery__pagination'),
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 1.15,
				spaceBetween: 18,
			},
		},
	});
});

const menuToggle = document.getElementById('mobile-menu-toggle');
const header = document.getElementById('header-wrapper');

if (menuToggle && header) {
	function setMobileMenu(open) {
		menuToggle.classList.toggle('is-open', open);
		header.classList.toggle('header-open', open);
		menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
		menuToggle.setAttribute('aria-label', open ? 'Mbyll menunë' : 'Hape menunë');
		document.body.style.overflow = open ? 'hidden' : '';
	}

	menuToggle.addEventListener('click', function () {
		setMobileMenu(!header.classList.contains('header-open'));
	});

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape') {
			setMobileMenu(false);
		}
	});

	header.querySelectorAll('.l-header__nav-parent a').forEach(function (link) {
		link.addEventListener('click', function () {
			setMobileMenu(false);
		});
	});
}

const submenuToggles = document.querySelectorAll('.nav-submenu-toggle');
const submenuParents = document.querySelectorAll('.nav-item--has-children');

function closeSubmenus(except = null) {
	submenuParents.forEach(function (item) {
		if (except && item === except) {
			return;
		}

		item.classList.remove('is-open');
		const toggle = item.querySelector('.nav-submenu-toggle');
		if (toggle) {
			toggle.setAttribute('aria-expanded', 'false');
		}
	});
}

submenuToggles.forEach(function (toggle) {
	toggle.addEventListener('click', function (event) {
		event.preventDefault();
		event.stopPropagation();

		const parent = this.closest('.nav-item--has-children');
		if (!parent) {
			return;
		}

		const willOpen = !parent.classList.contains('is-open');
		closeSubmenus(parent);
		parent.classList.toggle('is-open', willOpen);
		this.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
	});
});

document.addEventListener('click', function (event) {
	if (!event.target.closest('.nav-item--has-children')) {
		closeSubmenus();
	}
});

window.addEventListener('resize', function () {
	if (window.innerWidth > 991) {
		closeSubmenus();
		if (menuToggle && header) {
			menuToggle.classList.remove('is-open');
			menuToggle.setAttribute('aria-expanded', 'false');
			menuToggle.setAttribute('aria-label', 'Hape menunë');
			header.classList.remove('header-open');
			document.body.style.overflow = '';
		}
	}
});
